import React from "react";
import { AccessRoleCard } from "./AccessRoleCard";
import { AccessRoleUIProvider } from "./AccessRoleUIContext";

export function AccessRolePage({ history, match }) {
  const accessRoleUIEvents = {
    newAccessRoleButtonClick: () => {
      history.push("/admin/master-data/access-role/create");
    },
    openEditAccessRolePage: id => {
      history.push(`/admin/master-data/access-role/${id}/edit`);
    }
  };

  return (
    <AccessRoleUIProvider accessRoleUIEvents={accessRoleUIEvents}>
      <AccessRoleCard history={history} match={match} />
    </AccessRoleUIProvider>
  );
}
